import { render, staticRenderFns } from "./baseConfig.vue?vue&type=template&id=1333e000&scoped=true"
import script from "./baseConfig.vue?vue&type=script&lang=js"
export * from "./baseConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1333e000",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1333e000')) {
      api.createRecord('1333e000', component.options)
    } else {
      api.reload('1333e000', component.options)
    }
    module.hot.accept("./baseConfig.vue?vue&type=template&id=1333e000&scoped=true", function () {
      api.rerender('1333e000', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemAdministrator/creatApp/components/baseConfig.vue"
export default component.exports